import * as React from "react";
import { NavigationConfig, } from "../utils/navigation_config";
import AuthenticatedLayout from "../core/authentication";
import { lazyWithRetry } from "../utils/lazyWithRetry";
const LoginSignup = lazyWithRetry(() => import("../pages/loginSignup"), 'page-login');
const Dashboard = lazyWithRetry(() => import("../pages/dashboard/Dashboard"), 'page-dashboard');
const CreateApplication = lazyWithRetry(() => import("../pages/dashboard/createApplication"), 'page-create-app');
const QuoteTool = lazyWithRetry(() => import("../pages/quoteTool/QuoteTool"), 'page-quote-tool');
const LineOfCreditApplication = lazyWithRetry(() => import("../pages/dashboard/lineOfCredit"), 'page-loc');
const ScheduleLocInfo = lazyWithRetry(() => import("../pages/dashboard/scheduleTakedown/SelectLocList"), 'page-schedule-loc');
const ScheduleTakeDownApplication = lazyWithRetry(() => import("../pages/dashboard/scheduleTakedown"), 'page-schedule-takedown');
const DeepLinkMail = lazyWithRetry(() => import("../pages/deepLinkMail/DeepLinkMail"), 'page-deeplink');
const AnalyticsDashboard = lazyWithRetry(() => import("../pages/analyticsDashboard/AnalyticsDashboard"), 'page-analytics');
const QuoteHistory = lazyWithRetry(() => import("../pages/quoteTool/QuoteHistoryPage"), 'page-quote-history');
const QuotePreviewPage = lazyWithRetry(() => import("../pages/quoteTool/QuotePreviewPage"), 'page-quote-preview');
const ApplicationsPage = lazyWithRetry(() => import("../pages/dashboard/ApplicationsPage"), 'page-applications');
const ViewRateCardData = lazyWithRetry(() => import("../pages/dashboard/rateCard/viewRateCard"), 'page-rate-card');
const navConfig = NavigationConfig;
export const main_routes = [
    {
        path: "/*",
        element: React.createElement(LoginSignup, null),
    },
    {
        element: React.createElement(AuthenticatedLayout, null),
        children: [
            {
                path: navConfig.Account.Landing,
                element: React.createElement(Dashboard, null),
            },
            {
                path: navConfig.AnalyticsDashboard,
                element: React.createElement(AnalyticsDashboard, null),
            },
            {
                path: navConfig.CreateApplication,
                element: React.createElement(CreateApplication, null),
            },
            {
                path: navConfig.QuoteTool,
                element: React.createElement(QuoteTool, null),
            },
            {
                path: navConfig.QuoteHistory,
                element: React.createElement(QuoteHistory, null),
            },
            {
                path: navConfig.QuotePreview,
                element: React.createElement(QuotePreviewPage, null),
            },
            {
                path: navConfig.Applications,
                element: React.createElement(ApplicationsPage, null),
            },
            {
                path: `${navConfig.UpdateApplication}/:id`,
                element: React.createElement(CreateApplication, null),
            },
            {
                path: navConfig.LineOfCredit,
                element: React.createElement(LineOfCreditApplication, null),
            },
            {
                path: `${navConfig.UpdateLineOfCredit}/:id`,
                element: React.createElement(LineOfCreditApplication, null),
            },
            {
                path: navConfig.DealerOperatedRentalFleet,
                element: React.createElement(LineOfCreditApplication, null),
            },
            {
                path: `${navConfig.UpdateDealerOperatedRentalFleet}/:id`,
                element: React.createElement(LineOfCreditApplication, null),
            },
            {
                path: `${navConfig.LocDetailsByTaxId}`,
                element: React.createElement(ScheduleLocInfo, null),
            },
            {
                path: `${navConfig.ScheduleTakedownApplication}/:id`,
                element: React.createElement(ScheduleTakeDownApplication, null),
            },
            {
                path: navConfig.DeepLinkMail,
                element: React.createElement(DeepLinkMail, null),
            },
            {
                path: navConfig.SendApplicationLink,
                element: React.createElement(DeepLinkMail, null),
            },
            {
                path: navConfig.RateCard,
                element: React.createElement(ViewRateCardData, null),
            },
        ],
    },
];
